<template lang="pug">

#app-desktop.fw-bold
  audio(ref="bgm" :src="bgm" autoplay loop preload="auto")
  bg-pattern
  .bg-spark
  logo-sprite
  .desktop-cta
    img(src="~assets/ui/desktop2.png")
    img.m1(src="~assets/ui/m1.gif")
    img.m2(src="~assets/ui/m2.gif")
    img.wv(src="~assets/ui/wv.gif")

</template>

<script>
import BgPattern from 'src/components/vca/widgets/BgPattern'
import LogoSprite from 'src/components/vca/widgets/LogoSpriteD'
var bgm = require("assets/ui/bgm.txt")
export default {
  name: 'app',
  components: {
    BgPattern,
    LogoSprite

  },
  data() {
    return {
      timeline: 0,
      bgm: bgm
    }
  },
  computed: {},
  beforeMount() {},
  mounted() {
    this.$refs.bgm.play()
    document.addEventListener('visibilitychange', this.visibilityHandler)
  },
  methods: {
    visibilityHandler(){
      if (document.visibilityState === 'hidden') {
        this.$refs.bgm.pause()
      } else {
        this.$refs.bgm.play()
      }
    }
  },
}
</script>

<style lang="sass">
@import "src/styles/common.sass"
#app-desktop
  +full()
  background: linear-gradient(21.07deg, #2752A3 14.22%, #5E80D4 89.05%)
  overflow: hidden
  display: flex
  justify-content: center
  align-items: center
  .bg-pattern
    mix-blend-mode: color-burn
  .bg-spark
    +full()
    background: url("~assets/ui/spark.png") repeat
    background-size: 30%
  .logo-sprite
    z-index: 99
    margin-top: 5.65vh
    top: 0 !important
    .logosw
      width: 26.85vh !important
  .desktop-cta
    margin-top: 10vh
    height: 48.24vh
    position: relative
    img
      height: 100%
      object-fit: cover
    .m1
      position: absolute
      height: 72%
      top: 27%
      left: -3.1%
    .m2
      position: absolute
      height: 75%
      top: 9%
      right: -4.2%
    .wv
      position: absolute
      height: 9.2%
      top: 33.2%
      left: 38%




</style>
